let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fGnvp")).then(() => parcelRequire('jPPLT'));